import React from "react";
import { appVersion } from "../version";

/**
 * Displays version
 */
const Version = () => {
  return (
    <div className="font-['Manrope',serif] text-sm font-light whitespace-nowrap text-[#636262] w-full text-left app-version">
      v. {appVersion}
    </div>
  );
};

export default Version;
